// Session cache of an image's @lis.* properties, keyed by image id. Shared between the
// images table (which lazily streams case-info) and the detail-modal's CaseInformationPanel,
// so an image's properties are fetched at most once. Cleared on the images page "refresh".
const cache = new Map();

export function getCaseProps(id) {
  return cache.get(id);
}

export function setCaseProps(id, props) {
  cache.set(id, props);
}

export function hasCaseProps(id) {
  return cache.has(id);
}

export function clearCaseCache() {
  cache.clear();
}
